var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "button-wrapper" },
    [
      _vm._t("default", null, null, _vm.defaultScope),
      _vm._v(" "),
      _c(
        "a",
        {
          class: _vm.buttonClass,
          attrs: { href: _vm.generatedUrl, target: "book" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.handleClick($event)
            },
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar",
                ])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.handleClick($event)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.buttonLabel) + "\n  ")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }